import * as Sentry from "@sentry/react";

const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN;
const ENVIRONMENT = import.meta.env.VITE_ENVIRONMENT || "development";

export const initSentry = (): void => {
  if (!SENTRY_DSN) {
    console.warn("Sentry DSN not configured. Error tracking disabled.");
    return;
  }

  Sentry.init({
    dsn: SENTRY_DSN,
    environment: ENVIRONMENT,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
        // El mapa cambia el DOM en CADA cuadro (cámara y marcadores) y el
        // replay —que siempre graba en memoria por replaysOnErrorSampleRate
        // 1.0— serializaba cada cambio: ~1.4 s de CPU por cada 25 s siguiendo
        // una unidad (perfil 6-oct-2026). Grabar mosaicos tampoco sirve.
        block: [".gm-style"],
      }),
    ],
    tracesSampleRate: ENVIRONMENT === "production" ? 0.2 : 1.0,
    tracePropagationTargets: [
      "localhost",
      /^https:\/\/.*\.dumaxst\.com/,
      /^https:\/\/.*\.web\.app/,
      /^https:\/\/.*\.cloudfunctions\.net/,
    ],
    replaysSessionSampleRate: ENVIRONMENT === "production" ? 0.1 : 0,
    replaysOnErrorSampleRate: 1.0,
    beforeSend(event) {
      if (ENVIRONMENT === "development") {
        console.log("[Sentry] Event captured:", event);
      }
      return event;
    },
  });
};

export const captureException = (error: Error, context?: Record<string, unknown>): void => {
  if (context) {
    Sentry.setContext("additional", context);
  }
  Sentry.captureException(error);
};

export const captureMessage = (message: string, level: Sentry.SeverityLevel = "info"): void => {
  Sentry.captureMessage(message, level);
};

export const setUser = (user: { id: string; email?: string; username?: string } | null): void => {
  Sentry.setUser(user);
};

export const addBreadcrumb = (breadcrumb: Sentry.Breadcrumb): void => {
  Sentry.addBreadcrumb(breadcrumb);
};

export { Sentry };
